import type { NavTab, NavTabContext } from 'kci-design-lib';
import type { TabState } from './tabReducer';

export const selectTabs = (state: TabState): NavTab[] =>
  state.tabOrder.map((id) => state.tabsById[id]).filter((tab): tab is NavTab => Boolean(tab));

export const selectTabById = (state: TabState, tabId: string): NavTab | null =>
  state.tabsById[tabId] ?? null;

export const selectActiveTab = (state: TabState): NavTab | null =>
  selectTabById(state, state.activeTabId);

export const selectActiveTabContext = (state: TabState): NavTabContext | null =>
  selectActiveTab(state)?.context ?? null;